export default class ExperimentUtil {
    constructor(experimentData = []) {
        this.experimentData = experimentData;
    }

    getExperimentDataByName(experimentName) {
        return this.experimentData.find(
            experiment => experiment.name.toLowerCase() === experimentName.toLowerCase()
        );
    }

    getBucketByExperimentName(experimentName) {
        const experiment = this.getExperimentDataByName(experimentName);
        // Make it so we have the ability to tell later if there was no data or if we got control
        return experiment ? experiment.value : undefined;
    }

    getIdByExperimentName(experimentName) {
        const experiment = this.getExperimentDataByName(experimentName);
        return experiment ? experiment.id : undefined;
    }

    isTestVariant(experimentName, variant = 1) {
        const experiment = this.getExperimentDataByName(experimentName);
        return experiment && experiment.value === variant;
    }
}
